import { assert, Test } from "oc-e2e-testrunner";
import { assertSegmentIstLückenlosGefüllt, assertWarnungen, resetArrangement } from "./utils";
import { setEmptyAsMauer } from "../components/zauneditor/ZaunCircleMenuItemEmptyAsMauer";

export default {
  name: "TestEinzeltor",
};

const isVoreinstellungMitEAntrieb =
  APP.richMetadata.findAuswahlwert("E_Antrieb_mit")?.Voreinstellung;

export const testEinElementInEinerGefülltenStreckeWirdAufEinzeltorGeändert: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.verteilungsstrategieAuswahlwert_ = APP.richMetadata.findAuswahlwert("Gleichmässig");
  agt.grundriss.setStandardForm("Strecke", [5]);
  agt.update3d();
  const s = agt.segmente[0];
  const element = _.last(s.getElemente()) as any;
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  APP.arrangement.setSelectedObjects([element]);
  agt.update3d();
  agt.changeSelectedZaunElemente({
    massAuswahlwert,
    schaffePlatzFallsDoppeltor: false,
  });
  agt.update3d();
  assertSegmentIstLückenlosGefüllt(s);
};

export const testTorbreiteHängtVonMauerAb: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3]);
  agt.update3d();
  const s = agt.segmente[0];
  const element = agt.createElementFromJson({
    massAuswahlwert: "Einzeltor_Easy",
    breite: 1.8,
  });
  s.addPart(element);
  agt.update3d();
  assert.equals(1.8, element.breite);
  setEmptyAsMauer(agt.getEmpties()[0]);
  agt.update3d();
  assert.equals(1.2, element.breite);
  assertWarnungen(agt, [I18N("max. Flügelbreite %s m da Mauern", 1.2)]);
  assert.deepEquals(
    [I18N("max. Flügelbreite %s m da Mauern", 1.2)],
    APP.logMessagesForTests.map((l) => l.text)
  );
};
